/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTimecardBreakDefinitionRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {TimecardBreakDefinitionResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getTimecardBreakDefinition = (request: GetTimecardBreakDefinitionRequest, options?: CashRequestOptions) => post<GetTimecardBreakDefinitionRequest, TimecardBreakDefinitionResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetTimecardBreakDefinition", request, {...options, rejectOnError: true })